<template>
<v-card height="400">
    <v-container v-if="chart_data" fluid class="pa-0 ma-0">
        <v-card-title>
            <v-row align="center">
                <v-col cols="12">
                    <div class="d-flex">
                        <v-icon large class="mr-1">bar_chart</v-icon>
                        <div class="ml-1">
                            <div class="subheading text-uppercase">Agency Types</div>
                            <div class="heading grey--text">
                                {{from}}
                                <v-icon small class="pa-0 mt-0">arrow_right_alt</v-icon>
                                {{until}}
                            </div>
                        </div>
                        <im-chart-details :data="chart_data"></im-chart-details>
                    </div>
                </v-col>
            </v-row>
        </v-card-title>
        <v-divider class="mx-3" />
        <v-card-text>
            <im-bar-chart :data="chart_data" :options="chart_options" :height="300" />
        </v-card-text>
    </v-container>
    <v-container v-else fill-height align-center fluid class="pa-0 ma-0">
        <v-card-text>
            <div class="d-flex align-center justify-center fill-height">
                <v-progress-circular :size="75" color="primary" indeterminate />
            </div>
        </v-card-text>
    </v-container>
</v-card>
</template>

<script>
import BarChart from '../BarChart.vue'
import ChartDetails from '../ChartDetails.vue'
import moment from 'moment'

export default {

    components: {
        'im-bar-chart': BarChart,
        'im-chart-details': ChartDetails
    },

    props: {
        url: String,
        from: String,
        until: String
    },

    watch: {
        from: function () {
            this.getChart();
        },
        until: function () {
            this.getChart();
        }
    },

    methods: {
        getChart() {

            this.chart_data = null;
            this.chart_options = null;

            this.$axios.get(this.url + "/daily-agency-type-ratio", {
                    params: {
                        from: this.from,
                        until: this.until
                    }
                })
                .then(response => {

                    this.chart_data = {
                        labels: response.data.labels,
                        datasets: [
                            {
                                label: 'Sales (€)',
                                type: 'line',
                                borderColor: "#00B0FF",
                                backgroundColor: "#00B0FF",
                                yAxisID: 'sales',
                                fill: false,
                                pointRadius: 0,
                                hidden: true,
                                data: response.data.datasets.sales
                                },
                            {
                                label: 'HelloRomania',
                                type: 'bar',
                                yAxisID: 'ratio',
                                borderColor: "#FF9100",
                                backgroundColor: "#FF9100",
                                fill: false,
                                data: response.data.datasets.hello_romania
                                },
                            {
                                label: 'Q-Travel',
                                type: 'bar',
                                yAxisID: 'ratio',
                                borderColor: "#FFC400",
                                backgroundColor: "#FFC400",
                                fill: false,
                                data: response.data.datasets.q_travel
                                },
                            ]
                    };

                    this.chart_options = {
                        responsive: true,
                        maintainAspectRatio: false,
                        fill: false,
                        tooltips: {
                            mode: 'index'
                        },
                        legend: {
                            position: 'bottom'
                        },
                        scales: {
                            yAxes: [
                                {
                                    id: 'sales',
                                    type: 'linear',
                                    position: 'left',
                                    ticks: {
                                        min: 0,
                                        max: 2000
                                    }
                                    },
                                {
                                    id: 'ratio',
                                    type: 'linear',
                                    position: 'right',
                                    ticks: {
                                        min: 0,
                                        max: 10
                                    }
                                    }
                                ]
                        }
                    };

                });
        }
    },

    created() {
        this.getChart();
    },

    data() {
        return {
            chart_data: null,
            chart_options: null
        }
    }
}
</script>
